import React from "react";
import "./SanskritSubtitle.css";

/**
 * iCRAFTZ Design System · <SanskritSubtitle>
 *
 * The elegant, italic, subdued companion label used everywhere a
 * Sanskrit word sits under an English one (D26).
 *
 * Props
 * ─────
 * children    the Sanskrit text (e.g. "Bodha", "Sankalpa")
 * size        'sm' | 'md'    default 'md'
 * align       'center' | 'left'   default 'center'
 */
export function SanskritSubtitle({
  children,
  size = "md",
  align = "center",
  className = "",
  ...rest
}) {
  const cls = [
    "icz-sanskrit-subtitle",
    `icz-sanskrit-subtitle--${size}`,
    `icz-sanskrit-subtitle--${align}`,
    className,
  ].filter(Boolean).join(" ");
  return <span className={cls} aria-hidden="true" {...rest}>{children}</span>;
}

export default SanskritSubtitle;
